import { SECOND } from "@shared/models/constants/time.constant";

export const TOAST_SEVERITY_TYPES = {
    SUCCESS: "success", 
    INFO: "info", 
    WARNING: "warn",
    ERROR: "error"
} as const;

export const TOAST_DEFAULT_LIFETIME = 3 * SECOND